import { sessionPolicySchema, type SessionPolicy } from '@easyflow/shared';
import { decodeJwtPayload } from '@easyflow/ui-frontend';

export const AUTH_STORAGE_KEYS = {
  TOKEN: 'edgvoip_master_token',
  REFRESH_TOKEN: 'edgvoip_master_refresh_token',
  USER: 'edgvoip_master_user',
  BACKUP_TOKEN: 'edgvoip_master_backup_token',
  IMPERSONATION_ACTIVE: 'edgvoip_master_impersonation_active',
  IMPERSONATED_TENANT: 'edgvoip_master_impersonated_tenant',
  /** Policy di sessione (SessionPolicy, secondi) ricevuta da login/refresh. */
  SESSION_POLICY: 'edgvoip_master_session_policy',
} as const;

export const LEGACY_STORAGE_KEYS = {
  TOKEN: 'token',
  EDGVOIP_TOKEN: 'edgvoip-token',
  USER: 'user',
  IMPERSONATION_TOKEN: 'impersonation_token',
  MASTER_ORIGINAL_TOKEN: 'master_original_token',
  /** Deadline del vecchio tracker di inattività master (sostituito dal core `session-idle`). */
  SESSION_DEADLINE: 'edgvoip_master_session_deadline',
} as const;

export function migrateAuthStorage(): void {
  const legacyToken = localStorage.getItem(LEGACY_STORAGE_KEYS.TOKEN) || 
                      localStorage.getItem(LEGACY_STORAGE_KEYS.EDGVOIP_TOKEN);

  if (legacyToken && !localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN)) {
    const payload = decodeJwtPayload(legacyToken);
    if (payload?.is_master_tenant === true) {
      localStorage.setItem(AUTH_STORAGE_KEYS.TOKEN, legacyToken);
    }
  }

  const legacyBackup = localStorage.getItem(LEGACY_STORAGE_KEYS.MASTER_ORIGINAL_TOKEN) ||
                       sessionStorage.getItem('original_token');
  if (legacyBackup && !localStorage.getItem(AUTH_STORAGE_KEYS.BACKUP_TOKEN)) {
    localStorage.setItem(AUTH_STORAGE_KEYS.BACKUP_TOKEN, legacyBackup);
  }

  Object.values(LEGACY_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
  sessionStorage.removeItem('original_token');
  sessionStorage.removeItem('impersonating');
  sessionStorage.removeItem('impersonated_tenant');
}

export function clearAllAuthStorage(): void {
  Object.values(AUTH_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
  Object.values(LEGACY_STORAGE_KEYS).forEach(key => {
    localStorage.removeItem(key);
  });
  sessionStorage.clear();
}

/** Policy di sessione persistita (validata); null se assente o corrotta. */
export function readStoredSessionPolicy(): SessionPolicy | null {
  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEYS.SESSION_POLICY);
    if (!raw) return null;
    const parsed = sessionPolicySchema.safeParse(JSON.parse(raw));
    return parsed.success ? parsed.data : null;
  } catch {
    return null;
  }
}

export function storeSessionPolicy(policy: SessionPolicy): void {
  try {
    localStorage.setItem(AUTH_STORAGE_KEYS.SESSION_POLICY, JSON.stringify(policy));
  } catch {
    // Storage non disponibile: il core userà il fallback di policy.
  }
}
